.ux-cookie-layer-content {
    flex: 1 1 auto;
    display: block;
    width: 100%;
    overflow: auto;
    padding: 0 30px 15px;
    color: var(--ux-cookie-layer-text-color);

    p {
        color: var(--ux-cookie-layer-text-color);
        margin: 0 0 1em;
    }

    a {
        display: inline;
        color: var(--ux-cookie-layer-link-color);
        text-decoration: none;
        outline: 0 none transparent;
        transition: var(--ux-cookie-layer-link-transition);

        &:hover {
            color: var(--ux-cookie-layer-link-hover-color);
            text-decoration: none;
        }

        &:focus {
            color: var(--ux-cookie-layer-link-focus-color);
        }

        &:active {
            color: var(--ux-cookie-layer-link-active-color);
        }
    }
}
